/** @format */

import React from 'react';
import {Box} from '@chakra-ui/layout';
// eslint-disable-next-line react/prop-types, arrow-body-style
const FadedContainer = ({children}) => {
	return (
		<Box
			mb={10}
			sx={{
				maxHeight: '600px',
				WebkitMaskImage: 'linear-gradient(180deg, #000 40%, transparent)',
			}}>
			<Box>{children}</Box>
		</Box>
	);
};

export default FadedContainer;
